import { Badge, Box, Stack, Tooltip, Typography } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import {
  getStatusColour,
  statusToString,
} from '../../../../../../shared/utilities';
import { Statuses } from '../../../../../../types/status';
import { SurveyorAssignment } from '../../../../../../types/survey';
import { canShowSurveyorStatusBreakdown } from '../../../../../../shared/roomStatusDisplay';

type RoomStatusTableCellProps = {
  cell: {
    getValue: () => Statuses;
    row: {
      original: {
        surveyorStatus?: { [uid: string]: Statuses };
        surveyors?: { [uid: string]: SurveyorAssignment };
        canViewMultipleSurveyors?: boolean;
      };
    };
  };
};

const RoomStatusTableCell = ({ cell }: RoomStatusTableCellProps) => {
  const status = cell.getValue();
  const surveyorStatus = cell.row.original?.surveyorStatus || {};
  const surveyors = cell.row.original?.surveyors || {};
  const surveyorStatusEntries = Object.entries(surveyorStatus);
  const hasAdditionalSurveyorStatuses = canShowSurveyorStatusBreakdown({
    canViewMultipleSurveyors: !!cell.row.original?.canViewMultipleSurveyors,
    surveyorStatus,
  });

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography sx={{ color: getStatusColour(status) }}>
        {statusToString(status)}
      </Typography>
      {hasAdditionalSurveyorStatuses ? (
        <Tooltip
          title={
            <Stack spacing={0.5}>
              <Typography variant="body2" fontWeight="bold">
                Surveyor Statuses
              </Typography>
              {surveyorStatusEntries.map(([uid, surveyorRoomStatus]) => {
                const surveyorName = surveyors?.[uid]?.name || uid;
                return (
                  <Typography key={uid} variant="body2">
                    {surveyorName} -{' '}
                    <span
                      style={{ color: getStatusColour(surveyorRoomStatus) }}
                    >
                      {statusToString(surveyorRoomStatus)}
                    </span>
                  </Typography>
                );
              })}
            </Stack>
          }
        >
          <Box paddingRight={1}>
            <Badge
              badgeContent={surveyorStatusEntries.length - 1}
              color="primary"
            >
              <PersonAddIcon color="action" />
            </Badge>
          </Box>
        </Tooltip>
      ) : null}
    </Stack>
  );
};

export default RoomStatusTableCell;
